<script>
  import { onMount } from "svelte";
  import { user } from "../../firebase.js";
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();
  export let file;
  let done = false;
  console.log(file);
  let progress = 0;
  onMount(async () => {
    let link = await $user.create.file(file, (localprogress) => {
      console.log(localprogress);
      progress = localprogress;
    });
    if ((progress = 100.0)) {
      done = true;
    }
    dispatch("confirm", link);
    console.log(link);
  });
</script>

<div style="height:{progress}%" class:done class="upload-item" />

<style>
  .upload-item {
    position: absolute;
    background-color: var(--primaryColor);
    opacity: 0.7;
    height: 0;
    transition: all 0.8s ease;
    z-index: 2;
    width: 100%;
    display: flex;
    bottom: 0;
  }

  .done {
    opacity: 0;
    z-index: 0;
    transition: all 0.8s ease;
  }
</style>
